import { render, staticRenderFns } from "./JSearchSelectTag.vue?vue&type=template&id=9607145a&scoped=true"
import script from "./JSearchSelectTag.vue?vue&type=script&lang=js"
export * from "./JSearchSelectTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9607145a",
  null
  
)

export default component.exports